import { render, staticRenderFns } from "./SchModal.vue?vue&type=template&id=22cd97e6&scoped=true"
import script from "./SchModal.vue?vue&type=script&lang=js"
export * from "./SchModal.vue?vue&type=script&lang=js"
import style0 from "./SchModal.vue?vue&type=style&index=0&id=22cd97e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cd97e6",
  null
  
)

export default component.exports